import React from 'react'
import { Provider } from '../../../calculators/providers/common/Provider'
import { BoreholeFieldDefinitionsProps } from './BoreholeFieldDefinitions'
import { BoreholeField } from './BoreholeField'
import {
  createHarvestedDataForSystemContainer,
  createWasteInputDataForSystemContainer,
} from '../../../borehole-field-container/borehole-field-data-creator'

type Props = BoreholeFieldDefinitionsProps & {
  providers: Provider[]
}

export function SystemContainerBoreholeField({
  container,
  updateContainer,
  providers,
}: Props): React.ReactElement {
  const harvested = createHarvestedDataForSystemContainer(providers)
  const wasteInput = createWasteInputDataForSystemContainer(providers)

  return (
    <BoreholeField
      container={container}
      updateContainer={updateContainer}
      harvested={harvested}
      wasteInput={wasteInput}
    />
  )
}
